<template>
    <skeleton-wrapper
        :show_loading="show_loading"
        :skeleton_count="skeleton_count"
        skeleton_type="image, card-heading, list-item, actions"
        skeleton_height="380"
        :skeleton_col_props="{ cols: '12', sm: '6', lg: '4' }"
    >
        <slot />
    </skeleton-wrapper>
</template>

<script>
import SkeletonWrapper from '@/components/global/skeleton-wrapper.vue';

export default {
    components: {
        SkeletonWrapper,
    },

    props: {
        show_loading: {
            type: Boolean,
            default: false,
        },

        skeleton_count: {
            type: Number,
            default: 6,
        },
    },
};
</script>
